import { Router } from 'vue-router';
import { afterEachHook, beforeEachHook } from '@flinks/router-guard';
import {
  inviteLinkMiddleware,
  platformMiddleware,
  companyIdMiddleware,
  authMiddleware,
  titleMiddleware,
  whiteListMiddleware,
} from './middleware';

export default function registerGuard(router: Router) {
  beforeEachHook.use(
    companyIdMiddleware,
    inviteLinkMiddleware,
    platformMiddleware,
    whiteListMiddleware,
    authMiddleware
  );
  afterEachHook.use(titleMiddleware);
  beforeEachHook.register(router);
  afterEachHook.register(router);
}
